'use es6';

import 'i18n-data/static-1.76/data/currency';